import React from 'react';
import LazyLoad from 'react-lazyload';

class CommentsMigrana extends React.Component {
    render() {
        return (
        <LazyLoad height={1000} offset={300}>
            <div className="row" style={{background: "rgb(204, 153, 102)"}}>
              <div className="span6 offset3">
                <div id="comments" className="comments-area">
                  <h2 className="comments-title">19 comentarios en “<span>MIGRAÑA: SU RELACIÓN CON LA ALIMENTACIÓN</span>”</h2>
                  <ol className="comment-list">
                    <li id="comment-6521" className="comment even thread-even depth-1">


                      <b className="fn">Maria del valle</b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6521/index.html">
                        <time dateTime="2006-03-01T13:48:15+00:00">Miércoles, marzo 1, 2006 a las 1:48:PM</time>
                      </a>



                      <p>Soy una estudiante de la carrera Lic en Nutrición y estamos haciendo nuestro trabajo final sobre Migraña y alimentos, me gustaría que me mande info sobre el tema gracias!</p>


                    </li>
                    <li id="comment-6522" className="comment odd alt thread-odd thread-alt depth-1">


                      <b className="fn"><a href="http://example.com" rel="external nofollow" className="url">adriana vasthy</a></b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6522/index.html">
                        <time dateTime="2006-05-29T12:02:29+00:00">Lunes, mayo 29, 2006 a las 12:02:PM</time>
                      </a>



                      <p>Hola tengo una amiga on migraña y todo lo que nos puede enviar acerca de esto inclusive si hubiera la oportunidad de apoyar a mi amiga con problemas de migraña dándole un apoyo médico con un buen neurólogo le estaríamos agradecidos
                        muchas gracias mi teléfono es : 01984 80 36 889
                        playa del armen Quintana Roo. México</p>


                    </li>
                    <li id="comment-6523" className="comment even thread-even depth-1">


                      <b className="fn">Leticia B. Lozano</b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6523/index.html">
                        <time dateTime="2006-07-23T21:58:35+00:00">Domingo, julio 23, 2006 a las 9:58:PM</time>
                      </a>



                      <p>mi hermana come cosas con grasa y le viene la migraña tiene muy
                        mala alimentación por lo general solo come café con leche y
                        pan de dulce mucha leche y mucho café y mucho pan de dulce
                        yo le digo que es por su alimentación que me recomiendan para
                        que mejore sus hábitos alimenticios…</p>


                    </li>
                    <li id="comment-6524" className="comment odd alt thread-odd thread-alt depth-1">


                      <b className="fn"><a href="http://www.ilsevalle.com" rel="external nofollow" className="url">Ilse</a></b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6524/index.html">
                        <time dateTime="2006-08-12T12:52:01+00:00">Sábado, agosto 12, 2006 a las 12:52:PM</time>
                      </a>



                      <p>Hola Leticia B. Lozano
                        Parece cono si tu hermana no estuviera muy dispuesta a mejorar sus hábitos de alimentación. Yo lo que te puedo decir es que la persona necesita querer mejor y estar dispuesta a hacer cambios; si no, aunque baje Dios mismo no cambiará.
                        La cafeína contenida en el café es un detonante de la migraña; azúcares simples (como los contenidos en el pan dulce) también lo son. Hacer ejercicio moderado, como caminatas de 25 min, también ayuda a controlar la migraña.
                        Saludos</p>


                    </li>
                    <li id="comment-6525" className="comment even thread-even depth-1">


                      <b className="fn">alicia</b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6525/index.html">
                        <time dateTime="2006-08-22T15:29:08+00:00">Martes, agosto 22, 2006 a las 3:29:PM</time>
                      </a>



                      <p>hola!sufro de terribles dolores de cabeza me diagnosticaron migraña,
                        tengo tratamiento preventivo pero hago todo lo natural que puedo
                        para ayudarme, pero no calman,también tengo una alimentación sana,
                        pero sufro de constipación ¿puede tener relación?</p>


                    </li>
                    <li id="comment-6526" className="comment odd alt thread-odd thread-alt depth-1">


                      <b className="fn">floriberto torres</b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6526/index.html">
                        <time dateTime="2007-01-13T10:45:11+00:00">Sábado, enero 13, 2007 a las 10:45:AM</time>
                      </a>



                      <p>Hola todos los enfermos de migraña …soy poseedor de una técnica que te puede curar de la migraña en solo una o dos secciones , sin dietas ..sin intoxicar mas el cuerpo comunícate al 3005519670 o al fijo 4000082 de Bogota colombia …fl torres</p>


                    </li>
                    <li id="comment-6527" className="comment even thread-even depth-1">


                      <b className="fn">mariela</b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6527/index.html">
                        <time dateTime="2007-01-30T12:09:19+00:00">Martes, enero 30, 2007 a las 12:09:PM</time>
                      </a>



                      <p>hola
                        que es el utero invertido
                        espeor alguna respuesta</p>


                    </li>
                    <li id="comment-6528" className="comment odd alt thread-odd thread-alt depth-1">


                      <b className="fn">mariela</b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6528/index.html">
                        <time dateTime="2007-01-30T12:12:18+00:00">Martes, enero 30, 2007 a las 12:12:PM</time>
                      </a>



                      <p>Soy una estudiante de la carrera y estamos haciendo realizando
                        trabajo final sobre la Migraña
                        nos gustaria que me mande info sobre el tema</p>


                    </li>
                    <li id="comment-6529" className="comment even thread-even depth-1">


                      <b className="fn">Lilian</b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6529/index.html">
                        <time dateTime="2007-04-13T17:10:39+00:00">Viernes, abril 13, 2007 a las 5:10:PM</time>
                      </a>



                      <p>Me operaron de la vesícula depués de unos mese empece con Migraña.
                        Mi empieza viendo luces. Que será?.</p>


                    </li>
                    <li id="comment-6530" className="comment odd alt thread-odd thread-alt depth-1">


                      <b className="fn">CAROLINA</b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6530/index.html">
                        <time dateTime="2007-05-13T16:51:03+00:00">Domingo, mayo 13, 2007 a las 4:51:PM</time>
                      </a>



                      <p>HOLA, SOY ESTUDIANTE DEL ULTIMO AÑO DE LA CARRERA DE NUTRICION Y ESTOY PREPARANDO PARA MI TESIS FINAL, EL “TEMA MIGRAÑIA Y ALIMENTACION”. ME SERIA DE SUMA NECESIDAD QUE POR FAVOR, ME ENVIES INFORMACION ACTUALIZADA RESPECTO AL TEMA Y ESTUDIOS QUE SE HAYAN REALIZADO, ESPECIFICANDO DONDE, CUANDO Y QUIENES LO HICIERON. o BIEN REFERENCIA BIBLIOGRAFICA.
                        SE LO AGRADECERIA ENORMEMENTE!!
                        MUCHAS GRACIAS!!!
                        ESPERO RESPUESTA!!
                        SALUDOS.
                        CAROLINA.</p>


                    </li>
                    <li id="comment-6531" className="comment even thread-even depth-1">


                      <b className="fn">gabriela</b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6531/index.html">
                        <time dateTime="2007-08-29T15:10:42+00:00">Miércoles, agosto 29, 2007 a las 3:10:PM</time>
                      </a>



                      <p>hola:
                        soy estudiante de lic. en nutrición y mi trabajo de tesis es sobre la migraña y su alimentacion este interes surge ya que existe un 90%de que yo la padezca y me gustaria sabes si puedes mandarme mas informacion sobre es la migraña te lo agradeceria mucho de antemano gracias</p>


                    </li>
                    <li id="comment-6532" className="comment odd alt thread-odd thread-alt depth-1">


                      <b className="fn"><a href="http://example.com" rel="external nofollow" className="url">gris</a></b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6532/index.html">
                        <time dateTime="2007-09-03T10:42:02+00:00">Lunes, septiembre 3, 2007 a las 10:42:AM</time>
                      </a>



                      <p>hola tengo migraña desde hace 7años la verdad he estado en tratamientos y no me solucionan nada que puedo hacer</p>


                    </li>
                    <li id="comment-6533" className="comment even thread-even depth-1">


                      <b className="fn">gaby</b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6533/index.html">
                        <time dateTime="2007-10-03T23:26:21+00:00">Miércoles, octubre 3, 2007 a las 11:26:PM</time>
                      </a>



                      <p>Hola soy mujer de 23 años y de un día para el otro me surgió migraña, pero una muy rara, llamada <b>migraña vestibular</b>. se me presenta en oídos, equilibrio, dolor de cabeza y presión en el pecho. comúnmente se me presenta en mi ciclo premenstrual y menstrual, cerveza, entre otros.
                        El stress también es un fuerte causante de mi migraña.
                        solo quiero colaborar en este espacio comentando que en muchas personas
                        la migraña es una mezcla entre stress, alimentación y cambios hormonales, como yo.
                        gaby cabas</p>


                    </li>
                    <li id="comment-6534" className="comment odd alt thread-odd thread-alt depth-1">


                      <b className="fn">gaby</b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6534/index.html">
                        <time dateTime="2008-05-05T18:11:12+00:00">Lunes, mayo 5, 2008 a las 6:11:PM</time>
                      </a>



                      <p>hola
                        soy estudiante de nutrición y estoy por terminar la carrera por lo k
                        mi trabajo final es referente a la migraña….por lo k me gustaría y
                        se lo agradecería enormemente k si son tan a amblé de k m envíen
                        información sobre el tema ….de antemano gracias</p>


                    </li>
                    <li id="comment-6535" className="comment even thread-even depth-1">


                      <b className="fn">Raquel</b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6535/index.html">
                        <time dateTime="2008-07-19T04:17:32+00:00">Sábado, julio 19, 2008 a las 4:17:AM</time>
                      </a>



                      <p>Hola. Aunque en mi familia muchos padecen de migraña, yo nunca había sufrido ninguna…..hasta hace tres semanas. Me empezó con aura visual seguido de parestesia del lado derecho del cuerpo y cara. Me duró tres días en los que estuve ingresada porque los médicos se asustaron y querían descartar posible infarto cerebral, meningitis y esclerosis múltiple. Finalmente, el diagnóstico fue migraña seguramente debida a la ingesta de estrógenos (estradiol) porque por entonces estaba sometiéndome a un tratamiento hormonal para una fecundación in vitro por donación de ovocitos y al parecer el tratamiento (Meriestra o Proginova) aumenta el riesgo de trombosis, migrañas e infarto cerebral. Me dijeron que tenía una zona de falta de riego en el cerebro debido a algún pequeño infarto cerebral anterior y un cavernoma, pero no le dieron mucha importancia. Finalmente, la fecundación tuvo que suspenderse debido a la parestesia que sufrí y durante tres semanas todo ha estado en orden……hasta hace casi 5 días. Esta vez, la migraña (si es que es sólo una migraña) ha sido totalmente distinta y ha sucedido tan de repente y de forma tan extraña que estoy muy angustiada. Empezó una noche con un dolor repentino en todos los dientes de la boca al mismo tiempo (como si se pasaran todos los dientes al comer un helado), seguido de dolor en paladar y garganta y una parálisis temporal de la lengua, que me impidió hablar durante un minuto o así, como si me pesara enormemente (con la angustia enorme que eso me provocó). Después el dolor pasó a estar localizado detrás del ojo izquierdo y volví a empezar a tener hormigueo en el brazo y pierna derechos. Desde ese día, estos síntomas se han estado alternando durante todo el día sin parar. Cuando me duelen los dientes, cuando me cuesta hablar, o me duele el ojo, pero casi permanentemente tengo dormido brazo y pierna derechos y estoy como mareada y con fotofobia. He estado informándome y los síntomas se asemejan a dos variantes de la migraña con aura combinados: la hemipléjica (con parestesia en articulaciones y cara) y una que afecta a los maxilares (con dolor de dientes y dificultad para hablar) Aún así no soy médico y estoy asustadísima porque nadie se atreve a darme un diagnóstico claro. No le encuentro mucho sentido y el hecho de que durante unos minutos me duelan los dientes, luego el ojo y se me duerma a ratos la lengua o las extremidades, resulta incoherente y supongo que ridículo desde el punto de vista médico. Estoy desesperada porque llevo ya así cuatro días y esto no remite. No salgo a la calle porque me hace daño la luz, voy con gafas de sol por toda la casa, y me encuentro sin fuerzas, como si los músculos no me respondieran. Hay ratos que estoy bien, pero en otros es insoportable. No me duelen exactamente las sienes ni la cabeza como en la anterior migraña, pero sí tengo una presión continua en la nuca. He hablado con el neurólogo y estoy a la espera de que me trate un neurocirujano para decidir si me operan del cavernoma que me encontraron al hacerme una resonancia. Mi médico de cabecera me ha dicho que vea a un dentista, por si tuviera caries o una infección y que ese pueda ser el desencadenante porque me esté afectando al nervio trigémino. También quieren que me vea un fisioterapeuta, por si un problema maxilar o dental estuviera afectando las cervicales y eso explicara la parestesia y la presión en la nuca. Sólo sé que en unos días, sólo despertarme es un martirio y no pasa una hora sin que haya algún síntoma de los arriba mencionados que me esté afectando. Los médicos que me conocen descartan que sea psicológico, porque nunca he sido aprensiva. Es cierto que estoy bajo mucho estrés y un tanto deprimida, porque los últimos meses no han sido un camino de rosas: hace un año, en mi boda, me tuvieron que ingresar por cólicos en la vesícula, estuve ingresada tres meses y finalmente me operaron; hace tres meses tuve que abortar de 16 semanas porque mi bebé tenía una trisomía 13 (por una traslocación cromosómica que padezco) y no hace ni dos días se ha muerto mi abuela materna, lo que ha agravado la migraña que padecía desde hacía dos días porque no he podido estar en reposo con todo el lío del funeral. Así que supongo que todo esto me ha afectado mucho, pero aún así, quisiera descartar problemas dentales, cerebrales o de otro tipo. Quisiera recibir alguna opinión médica, para saber si lo de las afecciones dentales, la parestesia, el dolor en el ojo, los mareos y el dolor de cervicales pueda tener un mismo origen….y una posible solución. Ya no estoy con estrógenos, así que las hormonas están descartadas y quiero encontrarme al 100% antes de volver a intentar una fecundación porque con este cuadro sería algo inviable. Muchas gracias.</p>


                    </li>
                    <li id="comment-6536" className="comment odd alt thread-odd thread-alt depth-1">


                      <b className="fn">carolina</b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6536/index.html">
                        <time dateTime="2009-05-15T13:21:45+00:00">Viernes, mayo 15, 2009 a las 1:21:PM</time>
                      </a>



                      <p>HOLA, SOY ESTUDIANTE DEL ULTIMO AÑO DE LA CARRERA DE NUTRICIÓN Y ESTOY PREPARANDO PARA MI TESIS FINAL, EL “TEMA MIGRAÑA Y ALIMENTACIÓN”. ME SERIA DE SUMA NECESIDAD QUE POR FAVOR, ME ENVÍES INFORMACIÓN ACTUALIZADA RESPECTO AL TEMA Y ESTUDIOS QUE SE HAYAN REALIZADO, ESPECIFICANDO DONDE, CUANDO Y QUIENES LO HICIERON. o BIEN REFERENCIA BIBLIOGRÁFICA.
                        SE LO AGRADECERÍA ENORMEMENTE!!
                        MUCHAS GRACIAS!!!
                        ESPERO RESPUESTA!!
                        SALUDOS.
                        CAROLINA.</p>


                    </li>
                    <li id="comment-6537" className="comment even thread-even depth-1">


                      <b className="fn">Dani</b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6537/index.html">
                        <time dateTime="2010-04-22T16:05:45+00:00">Jueves, abril 22, 2010 a las 4:05:PM</time>
                      </a>



                      <p>Gaby leí q tienes migraña vestibular, si alguien mas la padece me podrían decir como se les quito?? Q tomaron? Cuanto topo les duro? Q síntomas tenían ? A mi me la diagnosticaron y llevo 3 meses mal y no se me ha quitado. Gracias
                        Daniela</p>


                    </li>
                    <li id="comment-6538" className="comment odd alt thread-odd thread-alt depth-1">


                      <b className="fn">daniela</b>

                      <a href="https://www.ilsevalle.com/blog/2005/10/migrana-su-relacion-con-la-alimentacion-3/#comment-6538/index.html">
                        <time dateTime="2010-08-30T12:47:05+00:00">Lunes, agosto 30, 2010 a las 12:47:PM</time>
                      </a>



                      <p>hola. a mi me diagnosticaron <b>migraña vestibular</b> recién ahora después de haberme hecho muchos estudios neurológicos y otorrinolaringólogos. hace mas de tres meses empecé a tener inestabilidad constante vértigo y mareos. ahora estoy mucho mejor pero no del todo bien. aparte de esto muchos días tengo dolor de cabeza en la parte de la frente la sienes y un poco mas arriba y cuando tomo algún tranquilizante también se mejora la inestabilidad. también se agudiza cuando tengo la menstruación o cuando estoy ovulando. parece que la forma de remediar esto es hacer sesiones de rehabilitación vestibular y algún tipo de ejercicio físico que no sea agresivo y en el que trabaje el equilibrio como por ejemplo yoga terapéutico o tai chi. además tener una alimentación sana y evitar las situaciones de stress. pero igual mas adelante les cuento que va pasando porque empezare dentro de poco las sesiones de rehabilitación. yoga ya estoy haciendo y empezare tai chi ni bien pueda. si haciendo esto persiste o empeora hay medicación pero mejor intentar algo de esto antes de empezar a medicarse. muchas gracias</p>


                    </li>

                  </ol>
                  <p className="no-comments">Los comentarios están cerrados.</p>
                </div>
              </div>
            </div>
</LazyLoad>
        );
    }
}

export default CommentsMigrana;
